import { useTranslation } from 'react-i18next'

const Maintenance: React.FC = () => {
  const { t } = useTranslation()
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-y-20 px-8 py-12 text-center">
      <div className="max-w-[600px]">
        <div>
          <h1 className="mb-4 font-sans text-4xl font-bold text-zinc-600">
            { t('pages.maintenance.title', { lng: 'en' }) }
          </h1>
        </div>
        <p className="font-body2 text-lg text-neutral-500">
          <strong>{ t('pages.maintenance.description', { lng: 'en' }) }</strong><br />
          <strong>{ t('pages.maintenance.description2', { lng: 'en' }) }</strong><br />
        </p>
      </div>

      <div className="max-w-[600px]">
        <div>
          <h1 className="mb-4 font-sans text-4xl font-bold text-zinc-600">
            { t('pages.maintenance.title', { lng: 'fr' }) }
          </h1>
        </div>
        <p className="font-body2 text-lg text-neutral-500">
          <strong>{ t('pages.maintenance.description', { lng: 'fr' }) }</strong><br />
          <strong>{ t('pages.maintenance.description2', { lng: 'fr' }) }</strong><br />
        </p>
      </div>
    </div>
  )
}

export default Maintenance
